import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { homeUrl } from "../utils/common_utils";
import { getJsonDataPostRequest } from "../utils/network_utils";
import { getAuth } from "../login/auth_utils";
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import { captureInstamojoGoogleAdsConversion } from "../google_ads/google_ads_helper";

function InstamojoPaymentRedirect() {
    const [error, setError] = useState('');
    const [showProgressBar, setShowProgressBar] = useState(true);
    const [redirectingToPremium, setRedirectingToPremium] = useState(false);

    const auth = getAuth();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const paymentId = searchParams.get('payment_id') || '';
    const paymentStatus = searchParams.get('payment_status') || '';
    const paymentOrderId = searchParams.get('id') || '';
    const transactionId = searchParams.get('transaction_id') || '';

    useEffect(() => {
        let redirectTimer = null;

        let data = {
            "auth": auth,
            "paymentId": paymentId,
            "transactionId": transactionId,
            "paymentStatus": paymentStatus,
            "paymentOrderId": paymentOrderId
        };

        let url = homeUrl() + "paymentsApi/paymentRedirect";

        getJsonDataPostRequest(url, data, function(response) {
            setShowProgressBar(false);

            if (response == null || response.status >= 400) {
                setError(response?.message || "Some error occurred, please try again after a few minutes");
                return;
            }

            if (auth && auth.userId) {
                captureInstamojoGoogleAdsConversion(auth.userId, 1560);
            }

            setRedirectingToPremium(true);

            redirectTimer = setTimeout(() => {
                window.location.href = '/premium';
            }, 3000);
        });

        return () => {
            if (redirectTimer) {
                clearTimeout(redirectTimer);
            }
        };

    }, []);

    return (
        <div className="flex flex-col mt-30 items-center justify-center">

            {showProgressBar &&
                <div className="z-50 mt-2">
                    <IndefiniteProgressBar />
                </div>
            }

            <br />

            <div className="text-center text-xl font-medium">
                {!redirectingToPremium && !error &&
                    <>
                        Payment in progress ... <br />
                        Please do not close this page, <br />
                        Do not press back button either
                    </>
                }

                {redirectingToPremium &&
                
                     <div>
                      <br /><br /><br /><br />
                    Please refresh premium page to see if transaction is successful.
                    <br /><br />

                    <a
                        href="/premium"
                        className="inline-flex items-center justify-center 
                        rounded-2xl bg-gradient-to-r from-blue-600
                         to-indigo-600 px-8 py-4 text-lg font-bold
                          text-white shadow-lg transition-all duration-200 
                          hover:scale-105 hover:from-blue-700
                           hover:to-indigo-700 hover:shadow-xl"
                    >
                        Open Premium Page
                    </a>

                    <br /><br />

                    <span className="text-base text-gray-600">
                        Redirecting to premium page in 3 seconds...
                    </span>
                </div>
                }
            </div>

            {error && error.length > 0 &&
                <div className="text-lg font-semibold text-red-700">
                    {error} <br />
                </div>
            }

        </div>
    );
}

export { InstamojoPaymentRedirect };